import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MediaDialogComponent, MediaDialogMode } from '../../../../shared/components/media-dialog/media-dialog.component';
import { Besprechung } from '../../../../generated-api';

@Component({
    selector: 'app-detail-icon-list',
    templateUrl: './detail-icon-list.component.html',
    styleUrls: ['./detail-icon-list.component.scss'],
    standalone: false
})
export class DetailIconListComponent {
  @Input() details: Besprechung;
  @Input() chips;
  dialogRef = null;

  constructor(private dialog: MatDialog) {
  }

  handleChipClick(src: any, srcName: string): void {
    this.dialogRef = this.dialog.open(MediaDialogComponent, {
      width: '400px',
      panelClass:"mat-dialog-container",
      data: {
        src: src,
        srcName: srcName,
        besprechungId: this.details.id,
        sourceType: this.details.srclist.find(value => value.src === src).channel,
        mode: MediaDialogMode.media,
        url: null,
        rating: this.details.rating.id
      }
    });
  }

  getRuntime(): number {
    return Math.round(this.details?.runtime / 60);
  }

  hasKino(): boolean {
    if (!this.details || this.details.srclist.length === 0) {
      return false;
    }
    return this.details.srclist.some(v => v.src === 'kino');

  }

}
